import token from "basic-auth-token";

//@ts-ignore
JSON.safeStringify = (obj, indent = 2) => {
  let cache = [];
  const retVal = JSON.stringify(
    obj,
    (key, value) =>
      typeof value === "object" && value !== null
        ? cache.includes(value)
          ? undefined // Duplicate reference found, discard key
          : cache.push(value) && value // Store value in our collection
        : value,
    indent
  );
  cache = null;
  return retVal;
};
export interface ApiSettings {
  apiKey?: string;
  apiSecret?: string;
  apiEndpoint: string;
  beaconConfig: string;
}

export class ApiBase {
  settings: ApiSettings;
  useBasicAuth: boolean;
  protected routePrefix: string = "";

  authToken() {
    let { apiKey, apiSecret } = this.settings;
    return token(apiKey, apiSecret);
  }
}
